import { render } from "./GradientDonut.vue?vue&type=template&id=2fb499d6"
import script from "./GradientDonut.vue?vue&type=script&lang=js"
export * from "./GradientDonut.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__